'use client';

import { c as _c } from "react/compiler-runtime";
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { TermAccordion } from '@/app/components/sections/service/service-center/terms/accordion';
import { ScriptFaqJsonLd } from '@/app/components/sections/service/service-center/terms/script-faq-json-ld';
import type { ServiceCenterTermsWithCanonicalProps } from '@/app/components/sections/service/service-center/terms/types';
import { useRevealAnim } from '@/app/hooks/useRevealAnim';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const ServiceCenterTermsSection = t0 => {
  const $ = _c(37);
  const {
    id: t1,
    jsonLdIdSuffix: t2,
    testId: t3,
    className,
    heading,
    items: t4,
    canonicalUrl,
    enableJsonLd: t5,
    accordionMode: t6,
    defaultExpandedIds,
    enableScrollIntoView: t7
  } = t0;
  const id = t1 === undefined ? "terms-and-conditions" : t1;
  const jsonLdIdSuffix = t2 === undefined ? "terms" : t2;
  const testId = t3 === undefined ? "terms" : t3;
  let t8;
  if ($[0] !== t4) {
    t8 = t4 === undefined ? [] : t4;
    $[0] = t4;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const items = t8;
  const enableJsonLd = t5 === undefined ? true : t5;
  const accordionMode = t6 === undefined ? "individual" : t6;
  const enableScrollIntoView = t7 === undefined ? false : t7;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      defaultBaseDelay: 0.04
    };
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  useRevealAnim(t9);
  if (items.length === 0) {
    return null;
  }
  const t10 = `${id}-heading`;
  let t11;
  if ($[3] !== className) {
    t11 = cn("bg-silver-100 relative w-full scroll-mt-14 overflow-hidden py-7 sm:py-10 xl:py-16", className);
    $[3] = className;
    $[4] = t11;
  } else {
    t11 = $[4];
  }
  const t12 = `${testId}-section`;
  let t13;
  if ($[5] !== t12) {
    t13 = createDataAttributes({
      test: t12
    });
    $[5] = t12;
    $[6] = t13;
  } else {
    t13 = $[6];
  }
  let t14;
  if ($[7] !== canonicalUrl || $[8] !== enableJsonLd || $[9] !== heading || $[10] !== items || $[11] !== jsonLdIdSuffix) {
    t14 = !!enableJsonLd && !!canonicalUrl && <ScriptFaqJsonLd idSuffix={jsonLdIdSuffix} items={items} canonicalUrl={canonicalUrl} heading={heading} />;
    $[7] = canonicalUrl;
    $[8] = enableJsonLd;
    $[9] = heading;
    $[10] = items;
    $[11] = jsonLdIdSuffix;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  const t15 = `${id}-heading`;
  let t16;
  if ($[13] !== heading) {
    t16 = {
      __html: heading
    };
    $[13] = heading;
    $[14] = t16;
  } else {
    t16 = $[14];
  }
  const t17 = `${testId}-heading`;
  let t18;
  if ($[15] !== t17) {
    t18 = createDataAttributes({
      test: t17
    });
    $[15] = t17;
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  let t19;
  if ($[17] !== t15 || $[18] !== t16 || $[19] !== t18) {
    t19 = <h2 id={t15} data-revealanim={true} className="text-sub-h1 font-noto-bold mb-6 text-gray-900 lg:mb-8" dangerouslySetInnerHTML={t16} {...t18} />;
    $[17] = t15;
    $[18] = t16;
    $[19] = t18;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] !== accordionMode || $[22] !== defaultExpandedIds || $[23] !== enableScrollIntoView || $[24] !== items || $[25] !== testId) {
    t20 = <TermAccordion defaultExpandedIds={defaultExpandedIds} items={items} accordionMode={accordionMode} enableScrollIntoView={enableScrollIntoView} testId={testId} data-revealanim={true} />;
    $[21] = accordionMode;
    $[22] = defaultExpandedIds;
    $[23] = enableScrollIntoView;
    $[24] = items;
    $[25] = testId;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t19 || $[28] !== t20) {
    t21 = <Container>{t19}{t20}</Container>;
    $[27] = t19;
    $[28] = t20;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== id || $[31] !== t10 || $[32] !== t11 || $[33] !== t13 || $[34] !== t14 || $[35] !== t21) {
    t22 = <Section id={id} aria-labelledby={t10} size="none" className={t11} {...t13} data-revealanim-group={true}>{t14}{t21}</Section>;
    $[30] = id;
    $[31] = t10;
    $[32] = t11;
    $[33] = t13;
    $[34] = t14;
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  return t22;
};
ServiceCenterTermsSection.displayName = 'ServiceCenterTermsSection';